import { Braces, ListChecks } from 'lucide-react'
import { SeoConfigTable } from './SeoConfigTable'
import { SEO_STR as S } from './seoApi'

/**
 * A12.07 — Indekslash siyosati. Path → robots-meta siyosati (index / noindex /
 * nofollow). CRUD `/admin/seo/index-policy` (fail-soft).
 */
export function IndexPolicyScreen() {
  return (
    <SeoConfigTable
      screenId="A12.07"
      title={S.indexPolicy}
      addLabel={S.addPolicy}
      path="/admin/seo/index-policy"
      listKey="entries"
      searchKeys={['path', 'policy']}
      icon={<ListChecks size={28} strokeWidth={1.5} />}
      fields={[
        { name: 'path', placeholder: '/*', mono: true },
        {
          name: 'policy',
          placeholder: S.policy,
          options: [
            { value: 'index,follow', label: 'index, follow' },
            { value: 'noindex', label: 'noindex' },
            { value: 'nofollow', label: 'nofollow' },
            { value: 'noindex,nofollow', label: 'noindex, nofollow' },
          ],
        },
      ]}
      columns={[
        { key: 'path', header: S.path, type: 'text' },
        { key: 'policy', header: S.policy, type: 'text' },
      ]}
    />
  )
}

/**
 * A12.09 — Strukturaviy ma'lumot (Schema.org). Path → JSON-LD tur/izoh.
 * CRUD `/admin/seo/schema` (fail-soft).
 */
export function SchemaOrgScreen() {
  return (
    <SeoConfigTable
      screenId="A12.09"
      title={S.schemaOrg}
      addLabel={S.addSchema}
      path="/admin/seo/schema"
      listKey="entries"
      searchKeys={['path', 'schema_type']}
      icon={<Braces size={28} strokeWidth={1.5} />}
      fields={[
        { name: 'path', placeholder: '/', mono: true },
        { name: 'schema_type', placeholder: 'Organization' },
        { name: 'notes', placeholder: S.notes },
      ]}
      columns={[
        { key: 'path', header: S.path, type: 'text' },
        { key: 'schema_type', header: S.schemaType, type: 'text' },
        { key: 'notes', header: S.notes, type: 'longtext' },
      ]}
    />
  )
}
